/**
 * The fix table (fixes.ts, 66 KB of rules) kept out of the first load
 * (notelen, 23 Oct 2026). The toast wrapper is in the shell, and importing the
 * table from there put every rule on every first visit; the bundle budget went
 * red on main with no PR at fault. The table is fetched once the first paint
 * is done, so an error almost always finds it already here.
 */
type Fixes = typeof import('./fixes');

let mod: Fixes | null = null;
let loading: Promise<Fixes> | null = null;

/** The table, when it has arrived; null before. */
export function fixesNow(): Fixes | null {
    return mod;
}

/** The table, fetched once. */
export function loadFixes(): Promise<Fixes> {
    loading ??= import('./fixes').then((m) => (mod = m));
    return loading;
}

if (typeof window !== 'undefined') {
    const idle = window.requestIdleCallback ?? ((cb: () => void) => window.setTimeout(cb, 1500));
    idle(() => { void loadFixes(); });
}
